import { getIcons } from "_helpers";

export { WarningItem };

/**
 * Composant qui affiche sur une ligne un icone remonté par le bus et son code
 * TODO: a compléter avec la définition du code VMC
 * @param {*} param0 
 * @returns 
 */
function WarningItem({warning}) {

    const { CODE_VMC, VALUE, URGENCY_LEVEL } = warning;

    // Définir la classe de couleur de fond en fonction du niveau d'urgence
    const getBackgroundColor = () => {
        if (VALUE === 0) return 'bg-global-lightgrey'; // Grisé si inactif
        switch (URGENCY_LEVEL) {
            case '1':
            case '2':
                return 'bg-primary-blue';
            case '3':
                return 'bg-primary-orange';
            case '4':
                return 'bg-primary-red';
            default:
                return 'bg-primary-green';
        }
    };

    const backgroundColor = getBackgroundColor();
    const iconCode = CODE_VMC.replace(/_$/, "")

    return (
        <div className="flex items-center space-x-4">
            <div className={`flex items-center justify-center w-10 h-10 rounded-lg ${backgroundColor} shadow-md`}>
                <span className={VALUE === 0 ? 'filter grayscale' : ''}>
                    <img src={getIcons(iconCode.replace(/_$/, ""))} alt={iconCode} title={iconCode} />
                </span>
            </div>
        </div>
    );
}